module.exports = __webpack_public_path__ + "static/media/fajl.ca8aa293.svg";